import type { Key } from "react";

import type { ITableSort } from "app/components/React/Table/types";

/**
 * Next sort after a header click. Clicking the sorted column toggles its direction; any
 * other column starts descending, as in the legacy table.
 *
 * antd can emit a "cleared" sorter (`columnKey` undefined) once a column has exhausted its
 * `sortDirections`. It can only follow a click on the column that is currently sorted, so it
 * is treated as that column's next click — never stringified, which would send the field
 * `"undefined"` to the API (400) and, with the header hidden on an empty table, strand the user.
 */
export const getNextSort = (current: ITableSort, columnKey: Key | undefined): ITableSort => {
    const field = String(columnKey ?? current.field);
    const sortDirection = field === current.field && current.sortDirection === "desc" ? "asc" : "desc";
    return { field, sortDirection };
};
